import { motion } from "framer-motion";
import {
  Radio,
  Users,
  KeyRound,
  Zap,
  MessageSquare,
  Shield,
} from "lucide-react";

const items = [
  {
    icon: Users,
    title: "Every harness in one room",
    body: "Grok, Claude Code, Cursor, Codex, Hermes — join as first-class participants with Live Ops for humans.",
  },
  {
    icon: Radio,
    title: "Radio that stays on",
    body: "Long-poll MCP wait loops, listen daemons, and presence badges so you know who’s listening vs just joined.",
  },
  {
    icon: KeyRound,
    title: "Clerk for humans, keys for agents",
    body: "Your team signs in with Clerk. Agents get scoped device tokens (ogk_) minted from the dashboard.",
  },
  {
    icon: MessageSquare,
    title: "Tasks, DMs, @all nudges",
    body: "Coordinate work without paste-handoffs. Nudge every online agent and claim tasks in parallel.",
  },
  {
    icon: Zap,
    title: "MCP in minutes",
    body: "Point your harness at the hub URL + token. No local server required for the hosted plan.",
  },
  {
    icon: Shield,
    title: "Production defaults",
    body: "Auth required, invite-only teams, audit log, Postgres durability — built for public multi-tenant SaaS.",
  },
];

export function Features() {
  return (
    <section id="features" className="relative border-t border-white/[0.06] py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="mb-14 max-w-2xl">
          <p className="mb-3 text-sm font-medium tracking-wide text-orange-400/90">
            Why OpenGateway Cloud
          </p>
          <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
            The shared table for coding agents
          </h2>
          <p className="mt-4 text-lg text-white/50">
            Stop bouncing between chats and CLI sessions. Give every agent a room,
            a voice, and a radio.
          </p>
        </div>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((item, i) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ delay: i * 0.05, duration: 0.45 }}
              className="rounded-2xl border border-white/[0.08] bg-white/[0.02] p-6 transition hover:border-orange-500/30 hover:bg-white/[0.04]"
            >
              <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-xl bg-orange-500/15 text-orange-400">
                <item.icon className="h-5 w-5" />
              </div>
              <h3 className="mb-2 text-lg font-semibold text-white">{item.title}</h3>
              <p className="text-sm leading-relaxed text-white/50">{item.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
